import { MutableRefObject } from "react";
import { Gallery, Item } from "react-photoswipe-gallery";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, H4, P } from "../../../../AbstractElements";
import { GalleryDescriptionTitle, GalleryTitle, Href, ImageGalleryDescriptionTitle, PortfolioTitle } from "../../../../Constants/Constants";
import { dynamicImage, dynamicNumber } from "../../../../Utils";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const GalleryDescriptionContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={GalleryDescriptionTitle} parent={GalleryTitle} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={ImageGalleryDescriptionTitle} />
              <CardBody className="my-gallery gallery-with-description mb-0">
                <Row>
                  <Gallery withCaption>
                    {dynamicNumber(4).map((item, i) =>
                      dynamicNumber(4).map((item, i) => (
                        <Col xl="3" sm="6" key={i}>
                          <figure itemProp="caption description">
                            <Item original={dynamicImage(`lightgallry/0${item}.jpg`)} caption="Using a camera's lens to record moments in time is the art form known as photography. To produce aesthetically striking photos, it entails the deft use of light, composition, and subject matter." width="802" height="476">
                              {({ ref, open }) => (
                                <Link to={Href} onClick={open}>
                                  <img className="img-thumbnail border-bottom-0 p-2 rounded-0 rounded-top-1" ref={ref as unknown as MutableRefObject<HTMLImageElement>} src={dynamicImage(`lightgallry/0${item}.jpg`)} alt="Image_description" />
                                  <div className="caption border-top-0 p-2">
                                    <H4 className="mt-0">{PortfolioTitle}</H4>
                                    <P>{"Using a camera's lens to record moments in time is the art form known as photography. To produce aesthetically striking photos, it entails the deft use of light, composition, and subject matter."}</P>
                                  </div>
                                </Link>
                              )}
                            </Item>
                          </figure>
                        </Col>
                      ))
                    )}
                  </Gallery>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default GalleryDescriptionContainer;
